import PropTypes from 'prop-types';
import React from 'react';
import EditableTableHeaders from 'editableTableHeaders';
import S from '../styles.scss';
import { isEqual } from 'lodash';

const EMPTY_TABLE = (<div className={S.emptyTable}>
  <h4>There are currently no records in this table</h4>
</div>);

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { headers: [], showDelete: true, showSave: true };
  }

  getChildContext = () => {
    const { isEditable, hasCustomControls } = this.props;
    return { isEditable, hasCustomControls, registerHeaders: this.registerHeaders };
  }

  registerHeaders = (headers = [], showDelete, showSave) => {
    if (isEqual(headers, this.state.headers)) return;
    this.setState({ headers, showDelete, showSave });
  }

  renderEmptyState = (children) => {
    const { isEditable, title, emptyNode, hasCreatableRow } = this.props;
    const ignoreLengthTitles = ['Warehouse Pads', 'Customer Satisfaction Survey', 'Leveler'];
    if (isEditable) return null;
    if ((hasCreatableRow && children.length === 1 && !ignoreLengthTitles.includes(title)) ||
      children.length === 0) return emptyNode;
    return null;
  }

  renderTable = children => (
    <table className={S.table} cellSpacing="0">
      <thead style={this.props.makeSticky ? { position: 'sticky', top: '138px', zIndex: '5' } : {}}>
        <EditableTableHeaders
          cells={this.state.headers}
          showDelete={this.state.showDelete}
          showSave={this.state.showSave}
        />
      </thead>
      <tbody>
        {children}
      </tbody>
    </table>
  );

  render = () => {
    const children = React.Children.toArray(this.props.children);
    return (<div>
      {this.renderTable(children)}
      {this.renderEmptyState(children)}
    </div>);
  }
}

EditableTable.childContextTypes = {
  isEditable: PropTypes.bool,
  hasCustomControls: PropTypes.bool,
  registerHeaders: PropTypes.func,
};

EditableTable.propTypes = {
  children: PropTypes.node.isRequired,
  isEditable: PropTypes.bool.isRequired,
  hasCustomControls: PropTypes.bool.isRequired,
  emptyNode: PropTypes.node,
  hasCreatableRow: PropTypes.bool,
  title: PropTypes.node,
  makeSticky: PropTypes.bool,
};

EditableTable.defaultProps = {
  children: null,
  isEditable: false,
  hasCustomControls: false,
  emptyNode: EMPTY_TABLE,
  hasCreatableRow: true,
  makeSticky: false,
};

export default EditableTable;



// WEBPACK FOOTER //
// ./client/app/shared/components/EditableTable/components/editableTable.jsx